import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import SydButton from '../../../../../commonDesign/Button'
import EmptySection from '../../../../../atoms/EmptySection'

function ComponentListSidebar ({
  presentations,
  selectedCode,
  onSelect,
  onAdd,
  onRemove
}) {
  const entries = Object.entries(presentations || {})

  return (
    <div style={{
      borderRight: '1px solid var(--color-neutral-600)',
      paddingRight: '16px',
      minHeight: '400px'
    }}
    >
      <div style={{ marginBottom: '12px' }}>
        <SydButton
          variant='primary'
          size='sm'
          icon='add'
          onClick={onAdd}
          style={{ width: '100%' }}
        >
          Add Component
        </SydButton>
      </div>

      {entries.length === 0 ? (
        <div style={{ paddingTop: '32px' }}>
          <EmptySection
            title='No Components'
            description='Click Add Component to get started'
            emptyDescription
          />
        </div>
      ) : (
        <div role='listbox' aria-label='Components'>
          {entries.map(([code, data]) => (
            <div
              key={code}
              role='option'
              tabIndex={0}
              aria-selected={selectedCode === code}
              onClick={() => onSelect(code)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  onSelect(code)
                }
              }}
              style={{
                padding: '12px',
                marginBottom: '8px',
                borderRadius: '4px',
                cursor: 'pointer',
                color: selectedCode === code ? 'var(--color-contrast-primary-500)' : 'inherit',
                backgroundColor: selectedCode === code ? 'var(--color-primary-500)' : 'transparent',
                border: selectedCode === code ? '1px solid var(--color-primary-500)' : '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: 'all 0.2s'
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, marginBottom: '2px' }}>{data.displayName}</div>
                <div style={{ fontSize: '0.75rem', color: 'var(--color-neutral-400)' }}>
                  {data.componentType} &bull; {code}
                </div>
              </div>
              <IconButton
                size='small'
                onClick={(e) => {
                  e.stopPropagation()
                  onRemove(code)
                }}
              >
                <DeleteIcon fontSize='small' />
              </IconButton>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

ComponentListSidebar.propTypes = {
  presentations: PropTypes.object.isRequired,
  selectedCode: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
}

export default ComponentListSidebar
